import { TrackableType } from "@redotech/redo-order-tracking-trackable-common/trackable";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  trackingTypeFromModel,
  validateTrackingTypeCondition,
  type TrackingTypeState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const TRACKING_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<TrackingTypeState>>,
): ConditionType<TrackingTypeState, ModelCondition.TrackingType> => ({
  name: CONDITION_NAMES[ModelCondition.TRACKING_TYPE],
  description(state) {
    return `Tracking type: ${state}`;
  },
  Details(props: ConditionTypeDetailsProps<TrackingTypeState>) {
    return React.createElement(Details, props);
  },
  empty: TrackableType.ORDER,
  fromModel(model: ModelCondition.TrackingType) {
    return trackingTypeFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.TRACKING_TYPE, trackingType: state };
  },
  valid(state) {
    return validateTrackingTypeCondition(state).valid;
  },
});
